import widont from 'widont';

export const toSentenceCase = (str: string | string[]) => {
  let normalizedString = '';
  if (Array.isArray(str)) {
    str.map((s, i) => {
      if (i === 0) {
        normalizedString = s.toLowerCase();
      } else {
        normalizedString += ` ${s.toLowerCase()}`;
      }
    });
  } else {
    normalizedString = str.toLowerCase();
  }
  return widont(
    normalizedString.charAt(0).toUpperCase() + normalizedString.slice(1)
  );
};

export const toTitleCase = (str: string) => {
  return str
    .split(' ')
    .map((word) => toSentenceCase(word))
    .join(' ');
};

export const removeWidows = (str: string | string[]) => {
  if (Array.isArray(str)) {
    return str.map((s) => widont(s));
  }
  return widont(str);
};
